import memoize from 'lodash/memoize';
import {
	type OperandName,
	OperandValues,
	FunctionName,
	KeywordName,
} from '../common/constants.tsx';
import { type PropTypes, PickerPropTypes } from '../common/types.tsx';

export const getValidOperandNames = memoize((propType: PropTypes): OperandName[] | undefined => {
	switch (propType) {
		case PickerPropTypes.IssueType:
			return [FunctionName.standardIssueTypes, FunctionName.subTaskIssueTypes];
		case PickerPropTypes.User:
			return [FunctionName.currentUser, KeywordName.empty, FunctionName.membersOf];
		case PickerPropTypes.CommonWithEmpty:
		case PickerPropTypes.Sprint:
			return [KeywordName.empty];
		case PickerPropTypes.Version:
			return [KeywordName.empty, FunctionName.releasedVersions, FunctionName.unreleasedVersions];
		default:
	}

	return undefined;
});

export const getValidOperandDisplayValues = memoize((propType: PropTypes): string[] | undefined =>
	getValidOperandNames(propType)?.map((name: OperandName) => OperandValues[name].value),
);
